import inote from '../assets/projects/i1.jpeg'
import tictactoe from '../assets/projects/t1.jpeg'
import Chatapp from '../assets/projects/chat.jpeg'

export const data=[
    {
        id:1,
        name:"iNote React Application",
        image:inote,
        github:"https://github.com/Kanhaiya9145/iNoteOn",
        live:"",
    },
    {
        id:2,
        name:"TicTacToe Game React Application",
        image:tictactoe,
        github:"https://github.com/Kanhaiya9145/TicTacToe_Game",
        live:"",
    },
    {
        id:3,
        name:"Real_Time_Chat_App",
        image:Chatapp,
        github:"https://github.com/Kanhaiya9145/Real_Time_Chat_App",
        live:"",
    },
]